import { ReactComponent as LogIcon } from 'assets/icons/log.svg'
import IconWrapper from 'components/IconWrapper'
import LogView from 'components/Log'
import { ModalWrapper, ModalHeader } from 'components/Modal'
import { bodyPrimaryColor } from 'styles/styleVariables'
import type { LogModalProps } from 'types'

const LogModal = (props: LogModalProps): JSX.Element => {
  const {
    logs,
    fillId,
    orderId,
    prescriptionId,
    prescriberId,
    autobotIds,
    parataNdcIds,
    patientId,
    escriptId,
    copayRequestId,
    updatedUserId,
    isCopay,
    details,
  } = props

  return (
    <ModalWrapper id="LogModal">
      <ModalHeader>
        <IconWrapper>
          <LogIcon fill={bodyPrimaryColor} />
        </IconWrapper>
        <h2>Log</h2>
      </ModalHeader>
      <LogView
        logs={logs || []}
        fillId={fillId}
        orderId={orderId}
        prescriptionId={prescriptionId}
        prescriberId={prescriberId}
        autobotIds={autobotIds}
        parataNdcIds={parataNdcIds}
        patientId={patientId}
        escriptId={escriptId}
        copayRequestId={copayRequestId}
        updatedUserId={updatedUserId}
        isCopay={isCopay}
        details={details}
      />
    </ModalWrapper>
  )
}

export default LogModal
